module.exports = __webpack_public_path__ + "img/geod_9.e1a9ad06.jpg";